import { UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { MyTripFindTripBy } from '@com-delta-idp/mnx-capability-trip-management-ui';
import {
  CONFIRMATION_NUM_VALIDATORS,
  CREDIT_CARD_VALIDATORS,
  TICKET_NUMBER_VALIDATORS
} from './mytrip-form.utils';

export function updateValidators(
  myTripFindTripBy: string,
  myTripWidgetFormGroup: UntypedFormGroup
) {
  switch (myTripFindTripBy) {
    case MyTripFindTripBy.CREDIT_CARD_NUMBER:
      clearValidators(
        [MyTripFindTripBy.TICKET_NUMBER, MyTripFindTripBy.CONFIRMATION_NUMBER],
        myTripWidgetFormGroup
      );
      setValidators(
        [
          {
            validatorKey: MyTripFindTripBy.CREDIT_CARD_NUMBER,
            validators: CREDIT_CARD_VALIDATORS
          }
        ],
        myTripWidgetFormGroup
      );
      return;
    case MyTripFindTripBy.TICKET_NUMBER:
      clearValidators(
        [
          MyTripFindTripBy.CREDIT_CARD_NUMBER,
          MyTripFindTripBy.CONFIRMATION_NUMBER
        ],
        myTripWidgetFormGroup
      );
      setValidators(
        [
          {
            validatorKey: MyTripFindTripBy.TICKET_NUMBER,
            validators: TICKET_NUMBER_VALIDATORS
          }
        ],
        myTripWidgetFormGroup
      );
      return;
    default:
      clearValidators(
        [MyTripFindTripBy.CREDIT_CARD_NUMBER, MyTripFindTripBy.TICKET_NUMBER],
        myTripWidgetFormGroup
      );
      setValidators(
        [
          {
            validatorKey: MyTripFindTripBy.CONFIRMATION_NUMBER,
            validators: CONFIRMATION_NUM_VALIDATORS
          }
        ],
        myTripWidgetFormGroup
      );
      return;
  }
}

export function clearValidators(
  clearValidatorKeys: string[],
  myTripWidgetFormGroup: UntypedFormGroup
) {
  clearValidatorKeys.forEach((clearValidatorKey) => {
    if (myTripWidgetFormGroup.get(clearValidatorKey)) {
      myTripWidgetFormGroup.get(clearValidatorKey)?.clearValidators();
      myTripWidgetFormGroup.get(clearValidatorKey)?.updateValueAndValidity();
    }
  });
}

export function setValidators(
  setValidators: Array<{ validatorKey: string; validators: ValidatorFn[] }>,
  myTripWidgetFormGroup: UntypedFormGroup
) {
  setValidators.forEach((setValidator) => {
    myTripWidgetFormGroup
      .get(setValidator.validatorKey)
      ?.setValidators(setValidator.validators);
    myTripWidgetFormGroup
      .get(setValidator.validatorKey)
      ?.updateValueAndValidity();
  });
}
